import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const UnlockIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.45 5.801a.56.56 0 0 1-.206.762l.264.832H4.41l.266-.835a.56.56 0 1 1 .775-.759Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.631 3.671h4.796V9H1.5V3.671h1.599v-.799a1.863 1.863 0 0 1 3.709-.267h-.539a1.332 1.332 0 0 0-2.638.267v.8ZM2.033 8.467h5.862V4.204H2.033v4.263Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const UnlockIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.45 5.801a.56.56 0 0 1-.206.762l.264.832H4.41l.266-.835a.56.56 0 1 1 .775-.759Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.631 3.671h4.796V9H1.5V3.671h1.599v-.799a1.863 1.863 0 0 1 3.709-.267h-.539a1.332 1.332 0 0 0-2.638.267v.8ZM2.033 8.467h5.862V4.204H2.033v4.263Z"
            />
        </SvgIcon>
    );
};
